<template>
	<div class="contract-apply-form">
        <p v-if="!applyReady || !rateReady" role="status">合约配置或汇率尚未就绪，请稍候或<button type="button" @click="getApplyInfo(); get_rate_data()">重试</button></p>
		<div style="padding: 6px;">
			<div style="display: flex;">
				<div style="display: flex;width: 50%;">
					钱包可用余额 
				</div>
				<div style="width: 50%;text-align: right"  v-if='userInfo != null'>￥{{userInfo.account}}</div>
			</div>
			<div style="display: flex;">
				<div style="display: flex;padding: 6px 0;width: 50%;justify-content: left;" >
					<div style="margin-right: 12px;" >汇率:</div>
					<div>1 {{ show_dw }} ≈ {{ rate }} CNY</div>
				</div>	
				<div style="width: 50%;padding: 6px 0;text-align: right" v-if='userInfo != null'>
				 ≈  {{c_floorToFixed(userInfo.account/rate,2)}} {{ show_dw }}
				</div>
			</div>
		</div>
		
		<div style="padding: 6px;">
			<div>合约类型</div>
			<div style="display: flex;flex-wrap: wrap;">
				<div v-for="item in availableMarkets" :key="item.value" @click="tapTypeClick(hylxLists.findIndex(row => row.value === item.value))" class="typeLisBox" :class="mktClassify==item.value?'selClass':''">
					{{item.name}}
				</div>
			</div>
			
		</div>
		<div style="padding: 6px;">
			<div>合同周期</div>
			<div style="display: flex;flex-wrap: wrap;">
				<div v-for="(item,index) in heyueTypeList" @click="selHYdef(index)" class="typeLisBox" :class="seltypeIndex==index?'selClass':''">
					{{item.name}}
				</div>
			</div>
		</div>
		<div style="padding: 6px;">
			<div>保证金</div>
			<div style="display: flex;flex-wrap: wrap;">
				<div v-for="(item,index) in bzjList" @click="bzjClick(index)" v-if='selDepositArr.indexOf(item.id+"")>=0' class="typeLisBox" :class="selBZJIndex==index?'selClass':''">
					{{item.name}}
				</div>
			</div>
			<div style="padding-top: 10px;padding-left: 10rpx;display: flex;">
				<div style="width: 50%;">
					<input type="text" class="hy-input__inner" @input="showmoney()" v-model="baozhengjin" placeholder="请输入自定义金额" >
				</div>
				<div style="width: 15%;line-height: 40px;margin-left: 8px;">{{show_dw}}</div>
                <div style="width: 35%;color: #f9272f;line-height: 40px;">≈ {{show_money}} CNY</div>
			</div>
			<!-- <div style="display: flex;padding: 20rpx;">
				<div class="con_name">汇率换算：</div>
				<div class="con_value"  style="color: #f9272f;">≈ {{show_money}} CNY</div>
			</div> -->
		</div>
		
		<div style="margin-top: 10px;">
			<div v-if="leversList[selleveIndex] && (selBZJIndex === -1 || bzjList[selBZJIndex])" style="font-weight: bold;color: var(--theme-label);">申请额度 ({{selBZJIndex==-1?c_floorToFixed(baozhengjin*leversList[selleveIndex].multiple,2):c_floorToFixed(bzjList[selBZJIndex].money*leversList[selleveIndex].multiple,2)}})</div>
			<div style="padding-top: 8px;display: flex;flex-wrap: wrap;">
				<div v-for="(item,index) in leversList"  v-if='selLeverArr.indexOf(item.id+"")>=0' @click="selleveIndex = index" 
				class="typeLisBox" :class="selleveIndex == index?'selClass':''">
					{{item.multiple}}倍
				</div>
			</div>
			<div style="margin: auto;width: 100%;">
				<button class="ljsq_btn" :disabled="!applyReady || !rateReady || ljsqstatus" @click="addedInfo()">立即申请</button>
			</div>
			<div style="display: flex;padding-top: 20px;justify-content: center;">
				<div style="display: flex;">
                    <el-checkbox style="margin-right: 6px;margin-top: -1px;" v-model="checkedPZ"></el-checkbox>
					<div @click="$u.route('/pagesB/my/peiziPage')">
						我已阅读并接受<text style="color: #3D68DB;">《配资协议》</text>
					</div>
				</div>
				
			</div>
		</div>
		
		<el-dialog title="确认申请" custom-class="pc-trade-dialog pc-contract-confirm" :visible.sync="applyInfoShow" append-to-body width="760px" :close-on-click-modal="false" :close-on-press-escape="!showLoading" :show-close="!showLoading">
			<div>

				<div v-if="applyInfo != null">
					<div class="d_f_j_b">
						<div class="applyInfoLis">
							<div>资金使用时间</div>
							<div>{{applyInfo.days}}天</div>
						</div>
						<div class="applyInfoLis">
							<div>
								总操盘资金
							</div>
							<div>{{applyInfo.money}}{{applyInfo.currency_code?applyInfo.currency_code:'元'}}</div>
						</div>
					</div>
					<div class="d_f_j_b">
						<div class="applyInfoLis">
							<div>保证金/本金</div>
							<div>{{applyInfo.deposit}}{{applyInfo.currency_code?applyInfo.currency_code:'元'}}</div>
						</div>
						<div class="applyInfoLis">
							<div>配资金额</div>
							<div>{{applyInfo.funding}}{{applyInfo.currency_code}}/{{applyInfo.multiple}}倍</div>
						</div>
					</div>	
					<div class="d_f_j_b">
						<div class="applyInfoLis">
							<div>亏损预警线
							</div>
							<div>{{applyInfo.loss_warn}}{{applyInfo.currency_code?applyInfo.currency_code:'元'}}</div>
						</div>
						<div class="applyInfoLis">
							<div>亏损平仓线
							</div>
							<div>{{applyInfo.loss_close}}{{applyInfo.currency_code?applyInfo.currency_code:'元'}}</div>
						</div>
					</div>	
					<div class="d_f_j_b">
						<div class="applyInfoLis">
							<div>个股仓位限制</div>
							<div>{{applyInfo.position_limit*100}}%</div>
						</div>
						<div class="applyInfoLis">
							<div>利率 
							</div>
							<div>{{applyInfo.ratio}}%</div>
						</div>
					</div>	
					<div class="d_f_j_b">
						<div class="applyInfoLis">
							<div>产生利息</div>
							<div>{{applyInfo.interest}}{{applyInfo.currency_code?applyInfo.currency_code:'元'}}</div>
						</div>
						<div  v-if="mktClassify>0" class="applyInfoLis">
							<div>会员利息抵扣</div>
							<div>{{applyInfo.user_interest_rebate}}</div>
						</div>
					</div>	
					<div v-if="mktClassify>0" class="d_f_j_b">
						<div class="applyInfoLis">
							<div>利息券抵扣 
							</div>
							<div>{{applyInfo.coupon_money_deduct}}{{applyInfo.currency_code}}</div>
						</div>
						<div class="applyInfoLis">
							<div>返现冻结抵扣
							</div>
							<div>{{applyInfo.blocked_money_deduct }}{{applyInfo.currency_code}}</div>
						</div>
					</div>	
					<div class="d_f_j_b">
						<div class="applyInfoLis">
							<div>可用利息券
							</div>
							<div>{{applyInfo.coupon_money}}{{mktClassify>0?applyInfo.currency_code:'元'}}</div>
						</div>
						<div class="applyInfoLis">
							<div>返现冻结余额 
							</div>
							<div>{{applyInfo.blocked_money}}{{mktClassify>0?applyInfo.currency_code:'元'}}</div>
						</div>
					</div>	
					<div v-if="mktClassify>0" class="d_f_j_b">
						<div class="applyInfoLis">
							<div>总抵扣 
							</div>
							<div>{{applyInfo.total_deduct}}{{applyInfo.currency_code}}</div>
						</div>
						<div class="applyInfoLis">
							<div>抵扣后利息 
							</div>
							<div>{{applyInfo.deduct_interest}}{{applyInfo.currency_code}}</div>
						</div>
					</div>	
					<div class="d_f_j_b">
						<div class="applyInfoLis">
							<div>准备资金 
							</div>
							<div>{{applyInfo.pre_money}}
								<text  v-if="mktClassify==0">元</text>
								<text  v-if="mktClassify>0">{{applyInfo.currency_code}} ≈ {{(applyInfo.pre_money*applyInfo.exchange_rate).toFixed(3)}}CNY</text>
							</div>
						</div>
						<div class="applyInfoLis">
							<div>利润分成
							</div>
							<div>{{applyInfo.point*100}}%</div>
						</div>
					</div>	
					<div class="d_f_j_b">
						<div class="applyInfoLis" v-if="mktClassify>0">
							<div>汇率</div>
							<div>{{applyInfo.exchange_rate}} {{applyInfo.currency_code}} ≈ 1.000 CNY</div>
						</div>
					</div>	
						
						
				</div>
			</div>
              
          <span slot="footer" class="order-confirm-actions"><el-button :disabled="showLoading" @click="applyInfoShow = false">取消</el-button><el-button type="primary" :loading="showLoading" :disabled="showLoading" @click="added()">确认申请</el-button></span>
        </el-dialog>
	
	</div>
</template>

<script>
    import { isContractPreview } from '@/utils/contractPreview'
    import { marketEnabled } from '@/utils/systemConfig'
import { getApplyInfoApi,indexExchangeRateInfo,addedInfoApi,createInfoApi,addedApi,gMcreatedApi } from "@/utils/requestapis";
    import { floorToFixed } from "@/utils/config";
	import { getCache } from "@/utils/cache";
	export default {
        name: "HeyueApply",
        props: { initialMarket: { type: Number, default: 0 } },
		data() {
			return {
				userInfo:null,
				selBZJIndex:0, // 已选择保证金
				bzjList:[], // 保证金列表
				selleveIndex:0,
				leversList:[],
				seltypeIndex:0 ,// 已选择合同类型
				heyueTypeList:[] ,//合同类型列表
				ljsqstatus:false,
				applyInfo:null,
                applyReady:false,
                rateReady:false,
                applyConfigRequest:0,
				applyInfoShow:false,
				questShow:false,
				questObj:{
					title:'',
					content:''
				},
				selDepositArr:[] ,// 当前合约类型可选保证金
				selLeverArr:[] ,// 当前合约类型可选保证金
				baozhengjin:'',
				showLoading:false,
				statusBarHeight:0,
				loss_warn_ratio:50,
				loss_close_ratio:20,
				mktClassify: this.initialMarket,
				hylxLists: [
				  { value: 0, name: 'A股','dw':'CNY' },
				  { value: 1, name: '港股','dw':'HKD' },
				  { value: 2, name: '美股','dw':'USD' }
				],
				rate_data:[],
				show_dw:'CNY',
				rate:'1.000',
				show_money:'',
                checkedPZ:true,
			}
		},
	
        mounted:function(){
			// if(option.mktClassify != undefined && option.mktClassify != ''){
			// 	this.mktClassify = option.mktClassify
			// }
			let a = getCache('config_data')
			if (a != undefined && a) {
				var sysconfig =  a
				if(sysconfig.consult != undefined){
					this.loss_warn_ratio  = parseInt(sysconfig.consult.loss_warn_ratio)
					this.loss_close_ratio = parseInt(sysconfig.consult.loss_close_ratio)
				}
				if (!(sysconfig.trade && sysconfig.trade.stock_hk_service &&  sysconfig.trade.stock_hk_service == '1')){
					this.hylxLists = this.hylxLists.filter((item, index) => item.value !== 1);
				}
				if (!(sysconfig.trade && sysconfig.trade.stock_us_service &&  sysconfig.trade.stock_us_service == '1')){
					this.hylxLists = this.hylxLists.filter((item, index) => item.value !== 2);
				}
			}
            this.getApplyInfo()
			this.get_rate_data()
        },
		
        beforeDestroy() { this.disposed = true },
		computed: { availableMarkets() { return this.hylxLists.filter(item => marketEnabled(({0:'cn',1:'hk',2:'us'})[item.value])) } },
        watch:{
			baozhengjin(){
				if(this.baozhengjin != ''){
					this.selBZJIndex = -1
				}
			
			}
		},
		methods: {
            c_floorToFixed(num){
                return floorToFixed(num,2)
            },
			showmoney(){
                if (!this.rateReady) { this.show_money = ''; return }
				if(this.baozhengjin != ''){
					this.show_money = this.c_floorToFixed(this.baozhengjin*this.rate,2)
				}else{
					if(this.selBZJIndex > -1 && this.bzjList[this.selBZJIndex]){
						this.show_money = this.c_floorToFixed(this.bzjList[this.selBZJIndex].money*this.rate,2)
					}
				}
				if(this.baozhengjin == '' && ( this.selBZJIndex == -1 || !this.bzjList[this.selBZJIndex])){
					
					this.show_money = ''
				}
                //this.show_money = ''
			},
			bzjClick(index){
				this.baozhengjin=''
				this.selBZJIndex = index
				this.showmoney()	
			},
			tapTypeClick(idx){
				let obj = this.hylxLists[idx]
				if(obj.value != this.mktClassify){
					this.mktClassify = obj.value
					this.getApplyInfo()
					this.show_dw = obj.dw
					this.rateReady = !!(this.rate_data[this.show_dw] && Number.isFinite(Number(this.rate_data[this.show_dw].rate)) && Number(this.rate_data[this.show_dw].rate) > 0)
					if (this.rateReady) this.rate = this.rate_data[this.show_dw].rate
					else this.get_rate_data()
					this.showmoney()	
				}
			},
			get_rate_data(){
                this.rateReady = false
                return indexExchangeRateInfo().then((data) => {
                    if (this.disposed) return
                    const currency = ({0:'CNY',1:'HKD',2:'USD'})[this.mktClassify]
                    if (!data || !data.rate_data || !data.rate_data[currency] || !Number.isFinite(Number(data.rate_data[currency].rate)) || !(Number(data.rate_data[currency].rate) > 0)) throw Error('汇率加载失败')
                    this.rate_data = data.rate_data
                    this.show_dw = currency
                    this.rate = this.rate_data[currency].rate
                    this.rateReady = true
                    this.showmoney()
                }).catch(() => { this.rateReady = false })
				
			},
			getLeversIdx(){
				if(this.selLeverArr.length == 0){
					return -1
				}
				if(this.heyueTypeList[this.seltypeIndex].id == 3){
					let len = this.leversList.length-1
					for(let i=len;i>0;i--){
						if(this.selLeverArr.indexOf(this.leversList[i].id+'')>-1){
							return i;
						}
					}
				}else{
					for(let i=0;i<this.leversList.length;i++){
						if(this.selLeverArr.indexOf(this.leversList[i].id+'')>-1){
							return i;
						}
					}
				}
				return -1
			},
			getBzjIdx(){
				if(this.selDepositArr.length == 0){
					return -1
				}
				for(let i=0;i<this.bzjList.length;i++){
					if(this.selDepositArr.indexOf(this.bzjList[i].id+'')>-1){
						return i;
					}
				}
				return -1
			},
			selHYdef(index){
				this.seltypeIndex = index
				this.selDepositArr = this.heyueTypeList[index].deposit.split(',')
				this.selLeverArr = this.heyueTypeList[index].lever.split(',')
				//bzjList
				this.selBZJIndex = this.getBzjIdx()
				this.selleveIndex = this.getLeversIdx()
				this.showmoney()
			},
			showQuest(num){
				switch (num){
					case 1:
						this.questObj = {
							title:"总操盘资金",
							content:'总操盘资金：总操盘资金=保证金+配资资金。'
						}
						break;
					case 2:
						this.questObj = {
							title:"亏损预警线",
							content:'亏损预警线：亏损预警线=保证金x'+this.loss_warn_ratio+'%+配资资金。'
						}
						break;
					case 3:
						this.questObj = {
							title:"亏损平仓线",
							content:'亏损平仓线：亏损平仓线=保证金x'+this.loss_close_ratio+'%+配资资金。'
						}
						break;
					case 4:
						this.questObj = {
							title:"利率",
							content:'利率利息：按天、按周、按月的合约，收取利息的利率是不一样的，具体以显示为准。交易日14:45之前申请的合约，当日开始计息。14:45之后的非交易日申请的合约下个交易日开始计息。'
						}
						break;
					case 5:
						this.questObj = {
							title:"资金使用时间",
							content:'资金使用时间：资金使用时间即操盘期限，按天合约最低2天，按周、按月最少一周、一月，所有类型合约到期自动续期，您也可以随时手动结算合约。'
						}
						break;
					case 6:
						this.questObj = {
							title:"可用利息券",
							content:'可用利息券：可用利息券=使用平台[手机app、桌面程序、web端等]内且适用范围[按天、按周、按月]内的可叠加利息券之和。'
						}
						break;
					case 7:
						this.questObj = {
							title:"返现冻结金额",
							content:'1.返现冻结是充值时赠送的返现资金，不可提现；<br/>2.申请、扩大和续期时产生的利息，优先使用利息券抵扣，利息券不足时解冻充值返现资金。'
						}
						break;
					case 8:
						this.questObj = {
							title:"准备资金",
							content:'准备资金=保证金+利息x资金使用时间-可用利息券；<br/>准备资金从钱包余额中扣除，若申请合约产生的利息未被利息券完全抵扣时，系统自动解冻相应充值返现资金。'
						}
						break;
					case 9:
						this.questObj = {
							title:"利润分成",
							content:'利润分成：免息配资不收取利息，您享有合约盈利部分'+(this.applyInfo.point*100)+'%的利润。'
						}
						break;
					case 10:
						uni.navigateTo({
							url:'/pagesB/gupiao/lixililv'
						})
						break;
					case 11:
						uni.navigateTo({
							url:'/pagesB/function/articlePage?id=70'
						})
						break;
						// this.questObj = {
						// 	title:"合约规则",
						// 	content:'1、交易日当天14:45之前申请当日计息，交易日当天14:45后或非交易日申请，下个交易日开始计息；<br/>2、随时(无持仓)可结算合约，利息扣除后不退还；<br/>3、温馨提示<br/>按天合约：申请按两日计息，自动续期按一日计息，非交易日免利息；<br/>按周合约：申请、自动续期按7自然日计息；<br/>按月合约：申请、自动续期按30自然日计息；<br/>免息合约：免利息，平台参与盈利分成，到期自动结算。'
						// }
						// break;
					case 12:
						this.questObj = {
							title:"钱包可用余额",
							content:'钱包可用余额=钱包余额'
						}
						break;
					default:
						break;
				}
				if(num != 10 && num != 11){
					this.questShow = true
				}
			},
			getSeltypeIdx(){
				if(this.heyueTypeList.length == 0){
					return -1
				}
				for(let i=0;i<this.heyueTypeList.length;i++){
					if(this.heyueTypeList[i].mode_id == 3){
						return i;
					}
				}
				return 0
			},
			getApplyInfo(){
                const request = ++this.applyConfigRequest
                this.applyReady = false
                return getApplyInfoApi({mkt_type:this.mktClassify}).then((data) => {
                    if (this.disposed || request !== this.applyConfigRequest) return
                    if (!data || !data.user || data.user.account == null || data.user.account === '' || !Number.isFinite(Number(data.user.account)) || !['modes','deposits','levers'].every(key => Array.isArray(data[key]) && data[key].length) || !data.modes.every(mode => typeof mode.deposit === 'string' && typeof mode.lever === 'string')) throw Error('合约配置加载失败')
                    this.heyueTypeList = data.modes
					this.bzjList = data.deposits
					this.userInfo = data.user
					this.leversList = data.levers
					this.seltypeIndex = this.getSeltypeIdx()
					this.selDepositArr = data.modes[this.seltypeIndex].deposit.split(',')
					this.selLeverArr = data.modes[this.seltypeIndex].lever.split(',')
					this.selBZJIndex = this.getBzjIdx()
					this.selleveIndex = this.getLeversIdx()
                    this.applyReady = !!this.leversList[this.selleveIndex]
                }).catch(() => { if (request === this.applyConfigRequest) this.applyReady = false })
				
			},
            async addedInfo(){
        if (!marketEnabled(({0:'cn',1:'hk',2:'us'})[this.mktClassify])) { this.$message.warning('当前市场暂未开放'); return }
        if (!this.checkedPZ) { this.$message.warning('请先阅读并接受配资协议'); return }
        if (!this.applyReady || !this.rateReady) { this.$message.warning('请先成功加载合约配置和汇率'); return }
        if (!this.heyueTypeList[this.seltypeIndex] || !this.leversList[this.selleveIndex] || (this.baozhengjin === '' && !this.bzjList[this.selBZJIndex])) { this.$message.warning('请选择合约类型、保证金和倍数'); return }
				if(this.ljsqstatus){
					return false
				}
				this.ljsqstatus = true
				this.applyInfoShow = false
				this.applyInfo = null
				try {
				const context = JSON.stringify([this.mktClassify, this.seltypeIndex, this.selBZJIndex, this.selleveIndex, this.baozhengjin])
				let data = {
					modeId:this.heyueTypeList[this.seltypeIndex].mode_id,
					depositId:this.baozhengjin == ''?this.bzjList[this.selBZJIndex].id:'',
					price:this.baozhengjin,
					leverId:this.leversList[this.selleveIndex].id,
					mktClassify:this.mktClassify,
					depositPrice:this.baozhengjin,
				}
				const res = await (this.mktClassify == 0 ? addedInfoApi(data) : createInfoApi(data))
				if (this.disposed || context !== JSON.stringify([this.mktClassify, this.seltypeIndex, this.selBZJIndex, this.selleveIndex, this.baozhengjin])) return
				if (!isContractPreview(res)) {
					if (res) this.$message.error('申请确认信息不完整，请重试')
					return
				}
				this.applyInfo = res
				this.applyInfoShow = true
				} catch (_) { /* The request interceptor reports transport failures. */ }
				finally { this.ljsqstatus = false }
			},
			added(){
        if (!this.checkedPZ) { this.$message.warning('请先阅读并接受配资协议'); return }
        if (!this.applyInfoShow || !isContractPreview(this.applyInfo)) return
        if (!marketEnabled(({0:'cn',1:'hk',2:'us'})[this.mktClassify])) { this.$message.warning('当前市场暂未开放'); return }
				if(this.showLoading){
					return false
				}
				this.showLoading = true
				let data = {
					modeId:this.heyueTypeList[this.seltypeIndex].mode_id,
					depositId:this.baozhengjin == ''?this.bzjList[this.selBZJIndex].id:'',
					price:this.baozhengjin,
					leverId:this.leversList[this.selleveIndex].id,
					mktClassify:this.mktClassify,
					depositPrice:this.baozhengjin,
				}
				
				if(this.mktClassify == 0){
					return addedApi(data).then((res) => {
						if (res === 0 || res === undefined) return
						const id = Number(res && res.id)
						if (!Number.isSafeInteger(id) || id <= 0) { this.$message.error('申请结果未确认，请先核对合约列表，勿重复申请'); return }
						this.applyInfoShow = false
						this.$emit('success', { id, market: 'cn' })
					}).catch(() => {}).finally(() => { this.showLoading = false })
					
				}else{
					return gMcreatedApi(data).then((res) => {
						if (res === 0 || res === undefined) return
						const id = Number(res && typeof res === 'object' ? res.id : res)
						if (!Number.isSafeInteger(id) || id <= 0) { this.$message.error('申请结果未确认，请先核对合约列表，勿重复申请'); return }
						this.applyInfoShow = false
						this.$emit('success', { id, market: this.mktClassify === 1 ? 'hk' : 'us' })
					}).catch(() => {}).finally(() => { this.showLoading = false })
				}
			},
			cancelMask: function () {
				var that = this; 
				setTimeout(function () {
					that.showLoading = false;
				}, 500); 
			},
		}
	}
</script>

<style>
	page{
		background-color: #fff;
	}
</style>
<style lang="scss" scoped>
	
	.eduListBox{
		width: 160px;text-align: center;position: relative;margin-bottom: 20px;
		margin-right: 10px;
		image{
			width: 100%;position: absolute;left: 0;height: 80px;
		}
	}
	
	.selMoneyBox{
		position: relative;height: 80px;box-sizing: border-box;color: white;line-height: 80px;
	}
	.noselEduClass{
		position: relative;height: 80px;box-sizing: border-box;
		border: 1px solid #f2f2f2;border-radius: 20px;background-color: #FFEDEB;line-height: 80px;
	}
	.typeLisBox{
		// width: 160rpx;background-color: #FFEDEB;
		// height: 80rpx;border-radius: 14rpx;
		line-height: 40px;text-align: center;
		margin-right: 10px;margin-top: 12px;
		width: 100px;color: var(--theme-label);
		height: 40px;
		background: var(--theme-input);
		border-radius: 10px;
		
	}
	.selClass{
		background-color: var(--theme-accent);color: #fff;
	}
	.applyInfoLis{
		display: flex;
		width: 45%;
		justify-content: space-between;
		height: 40px;line-height: 40px;
	}
	.applyInfoBtn{
		width: 50%;text-align: center;padding: 30px 0;
		border-top: 4px solid #f2f2f2;font-size: 30px;
	}
	.applyInfoBtn:nth-child(2n){
		border-left: 4px solid #f2f2f2;color: #DD5054;
	}
	// .applyInfoLis div:nth-child(2n){
	// 	text-align: right;
	// }
	// .applyInfoLis div:nth-child(1){
	// 	display: flex;
	// }
	.questClass{
		margin-left: 20px;
	}
   
    .hy-input__inner {
        background-color: var(--theme-input);
        border-radius: 4px;
        border: 1px solid var(--theme-border);
        box-sizing: border-box;
        color: var(--theme-text);
        display: inline-block;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 100%;
    }
    .ljsq_btn {
        position: relative;
        display: block;
        margin-left: auto;
        margin-right: auto;
        padding-left: 14px;
        padding-right: 14px;
        box-sizing: border-box;
        font-size: 18px;
        text-align: center;
        text-decoration: none;
        line-height: 2.55555556;
        border-radius: 5px;
        -webkit-tap-highlight-color: transparent;
        overflow: hidden;
        cursor: pointer;
        background: #f93f30;color: white;
        margin-top: 12px;width: 100%;border-radius: 6px;height: 36px;line-height: 36px;font-size: 14px;
        border: none;
    }
</style>
